import { useAuthentication } from '@printdeal/authentication';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, type ReactNode } from 'react';
import { clearSegmentationOnLogout } from '../../helpers/segmentationLogout';

interface Props {
  children: ReactNode;
}

/**
 * Second of two intentional logout cleanups (first: authCompatibilityMiddleware on
 * logoutSuccess). Runs after SegmentationProvider's invalidateQueries so
 * clearSegmentationOnLogout can cancel the in-flight /customerProgramData refetch;
 * duplicate calls are safe via idempotent guard in segmentationLogout.
 */
const SegmentationLogoutCoordinator = ({ children }: Props) => {
  const authenticationService = useAuthentication();
  const queryClient = useQueryClient();

  useEffect(() => {
    const unsubscribe = authenticationService.onLogout(() => {
      clearSegmentationOnLogout(queryClient);
    });

    return unsubscribe;
  }, [authenticationService, queryClient]);

  return children;
};

export default SegmentationLogoutCoordinator;
